/*
  © 2025 KondaSoft
  https://www.kondasoft.com
*/
class CrossSells extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll(".cross-sells-secondary-list input[type='checkbox']").forEach((checkbox, index) => {
      checkbox.addEventListener("change", () => {
        this.querySelector(`.cross-sells-list-images-item:nth-child(${index + 1})`).style.opacity = checkbox.checked ? "1" : ".2";
      });
    });

    this.querySelectorAll(".cross-sells-secondary-list select").forEach((select, index) => {
      select.addEventListener("change", () => {
        const selectedOption = select.options[select.selectedIndex];

        const variantImage = selectedOption.dataset.variantImage;
        if (variantImage.length) {
          const productImage = this.querySelector(`.cross-sells-list-images-item:nth-child(${index + 1}) img`);
          productImage.src = variantImage;
        }

        const variantComparePrice = selectedOption.dataset.variantComparePrice;
        const variantPrice = selectedOption.dataset.variantPrice;

        select.closest(".cross-sells-secondary-list-item").querySelector("[data-price-compare").textContent = window.Shopify.formatMoney(variantComparePrice);
        select.closest(".cross-sells-secondary-list-item").querySelector("[data-price-sale").textContent = window.Shopify.formatMoney(variantPrice);
        select.closest(".cross-sells-secondary-list-item").querySelector("[data-price-regular").textContent = window.Shopify.formatMoney(variantPrice);
      });
    });

    this.adjustLayout();
  }

  adjustLayout() {
    const task = () => {
      const footer = this.querySelector(".cross-sells-footer");
      if (window.matchMedia("(max-width: 1199px)").matches) {
        this.querySelector(".cross-sells-secondary-list").insertAdjacentElement("afterend", footer);
      } else {
        this.querySelector(".cross-sells-list-images").insertAdjacentElement("afterend", footer);
      }
    };
    task();
    window.addEventListener("resize", task);
    window.addEventListener("orientationchange", task);
  }
}
customElements.define("cross-sells", CrossSells);
